import {Method} from "../Method"
import RequestBuilder from "../RequestBuilder"

export class UploadRequests {
  static getByCode(code: string): Promise<any> {
    return new RequestBuilder(Method.Get, `uploads/${code}`).buildAndSend()
  }

  static deleteByLink(link: string): Promise<void> {
    return new RequestBuilder(Method.Delete, link, false).buildAndSend()
  }

  static deleteByCode(code: string): Promise<void> {
    return new RequestBuilder(Method.Delete, `uploads/${code}`).buildAndSend()
  }
}